/* 
	Molly Lentz 7.20.18
	Adapted from: https://gomakethings.com/how-to-add-transition-animations-to-vanilla-javascript-show-and-hide-methods/
	on pageload:					var accountAccordions = new getAccordions4i();
	enable:  						accountAccordions.init();
	open/close are also available:  	accountAccordions.close(document.getElementById("SaleSection"));
	css needed: components/_accordion.scss
	see below for HTML example
*/

var getAccordions4i = function(){
	var init = function (container){
		var accordionHdrs = container.querySelectorAll(".accordionHeader");
		for(var x = 0; x < accordionHdrs.length; x++){
			accordionHdrs[x].removeEventListener("click", togglePanel, false);
			accordionHdrs[x].addEventListener("click", togglePanel, false);
		}		
	},
	open = function (elem) {
		var panel = elem;
		var header = panel.previousElementSibling;
		var headerBtn = header.firstElementChild;
		var getHeight = function () {
			panel.style.display = "block";
			var height = panel.scrollHeight + "px"; 
			panel.style.display = ''; 
			return height;
		};
		
		var height = getHeight();
		panel.style.height = height; 
		
		panel.classList.add("open"); 
		panel.setAttribute("aria-hidden", "false");
		headerBtn.setAttribute("aria-expanded", "true");
	
		// This is important so content can scale responsively
		// Also focuses on the first link in the panel if there is one
		setTimeout(function() {
			panel.style.height = '';
			//firstLinkFocus(elem); /* site improve did not like 5/7/2020 */
		}, 300);
	},
	close = function (elem) {
		var panel = elem;
		var header = panel.previousElementSibling;
		var headerBtn = header.firstElementChild;
		// Give the element a height to change from
		elem.style.height = panel.scrollHeight + 'px';
		
		panel.setAttribute("aria-hidden", "true");
		headerBtn.setAttribute("aria-expanded", "false");

		setTimeout(function() {
			panel.style.height = '0';
		}, 1);
		setTimeout(function() {
			// When the transition is complete, hide it
			panel.classList.remove("open");
		}, 300);	
	},
	openAll = function(container){
		var accordionHdrs = container.querySelectorAll(".accordionHeader");
		for(var i = 0; i < accordionHdrs.length; i++){
			var accordionBtnParent = accordionHdrs[i].parentNode;
			var accordionPanel = accordionBtnParent.nextElementSibling;
			open(accordionPanel);
		}		
	},
	closeAll = function(container){
		var accordionHdrs = container.querySelectorAll(".accordionHeader");
		for(var i = 0; i < accordionHdrs.length; i++){
			var accordionBtnParent = accordionHdrs[i].parentNode;
			var accordionPanel = accordionBtnParent.nextElementSibling;
			close(accordionPanel);
		}		
	},
	/*firstLinkFocus = function(el){
		// important to add "disabled" text to hidden inputs in order to not collect them here
		var thisPanel = el;
		var focusableEls = thisPanel.querySelectorAll('a, button:not([disabled]), [href], .close4iDialog, input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
		
		if(focusableEls[0] !== undefined){
			focusableEls[0].focus();
		}
	},*/
	togglePanel = function (e) {
		e.preventDefault();
		var header = this;
		var accordionBtnParent = header.parentNode,
			accordionPanel = accordionBtnParent.nextElementSibling;
				
		if (accordionPanel.classList.contains("open")) {
			close(accordionPanel);
			return;
		}
		open(accordionPanel);
	};
	
	return {
		init: init,
		close: close,
		open: open,
		openAll: openAll,
		closeAll: closeAll
	};
};


/* 
  OPEN ACCORDION HTML:
	<h2 class="marginTop20">
		<button class="accordionHeader text20 bkgdLtGray padding10 fullWidth pointer" aria-expanded="true">
			<span class="floatLeft">Accordion Header</span>
			<svg class="arrowIcon textDarkestGray floatRight" height="25px" width="25px" aria-hidden="true"><use xlink:href="#svgIcon-arrowSolid"></use></svg>
		</button> 
	</h2>
	<div class="accordionPanel open" aria-hidden="false">
		<div class="padding10 borderMdGray">
			<p>Your content would go inside the div surrounding it. Div nested inside the accordionPanel div needs to be here as this is how the height on the panel gets calculated for animation.</p>
		</div>
	</div>
	
  CLOSED ACCORDION HTML:
	<h2 class="marginTop20">
		<button class="accordionHeader text20 bkgdLtGray padding10 fullWidth pointer" aria-expanded="false">
			<span class="floatLeft">Accordion Header</span>
			<svg class="arrowIcon textDarkestGray floatRight" height="25px" width="25px" aria-hidden="true"><use xlink:href="#svgIcon-arrowSolid"></use></svg>
		</button> 
	</h2>
	<div class="accordionPanel" aria-hidden="true">
		<div class="padding10 borderMdGray">
			<p>Your content would go inside the div surrounding it. Div nested inside the accordionPanel div needs to be here as this is how the height on the panel gets calculated for animation.</p>
		</div>
	</div>
*/